import { Head } from "vike-react/Head";
import { routes } from "@/i18n/routes";
import { useLanguage } from "@/i18n/LanguageContext";
import type { Language } from "@/i18n/translations";
import { usePageContext } from "vike-react/usePageContext";
import { useMemo } from "react";

const SeoHreflang = () => {
  const pageContext = usePageContext();
  const { language } = useLanguage();
  const domain = "https://fourleaves.pl";

  const routeKey = useMemo(() => {
    const currentPathname = pageContext.urlPathname;
    const currentLang = language;

    let pathWithoutLang = currentPathname.replace(`/${currentLang}/`, "").replace(`/${currentLang}`, "");
    if (pathWithoutLang === "" && currentPathname === `/${currentLang}`) pathWithoutLang = "";

    for (const [key, translations] of Object.entries(routes)) {
        if (key === 'services') continue;
        if ((translations as any)[currentLang] === pathWithoutLang) return key;
    }

    for (const [key, translations] of Object.entries(routes.services)) {
        if ((translations as any)[currentLang] === pathWithoutLang) return `services.${key}`;
    }

    if (pathWithoutLang.startsWith(routes.catalog[currentLang] + "/")) return "productDetail";
    if (pathWithoutLang === "" || pathWithoutLang === "/") return "home";

    return null;
  }, [pageContext.urlPathname, language]);

  if (!routeKey) return null;

  const languages: Language[] = ["pl", "en", "de"];

  return (
    <Head>
      {languages.map((lang) => {
        let path = "";
        if (routeKey === "productDetail") {
            const slug = pageContext.urlPathname.split("/").pop();
            path = `${routes.catalog[lang]}/${slug}`;
        } else if (routeKey.startsWith("services.")) {
            const serviceKey = routeKey.split(".")[1] as keyof typeof routes.services;
            path = routes.services[serviceKey][lang];
        } else {
            path = (routes as any)[routeKey][lang];
        }
        const url = `${domain}/${lang}${path ? `/${path}` : ""}`;
        return <link key={lang} rel="alternate" hrefLang={lang} href={url} />;
      })}
      <link rel="alternate" hrefLang="x-default" href={`${domain}/pl${(routes as any)[routeKey]?.pl ? `/${(routes as any)[routeKey].pl}` : ""}`} />
    </Head>
  );
};

export default SeoHreflang;
